import Credits from "./Components/Credits";

export default Credits;
